import { trpcSlice } from "../trpcSlice";

export type TExternalIssueBannerSeverity = "info" | "warning" | "error";

export interface IExternalIssueBanner {
  _id: string;
  source: string;
  message: string;
  severity: TExternalIssueBannerSeverity;
  isActive: boolean;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt?: string | Date;
  updatedAt?: string | Date;
}

type TExternalIssueBannerInput = {
  source: string;
  message: string;
  severity: TExternalIssueBannerSeverity;
  isActive: boolean;
};

export const externalIssueBannerRTK = trpcSlice.injectEndpoints({
  endpoints: (builder) => ({
    getActiveExternalIssueBanners: builder.query<IExternalIssueBanner[], void>({
      query: () => ({
        url: "/appadmin/external-issue-banners/active",
      }),
      providesTags: ["ExternalIssueBanners"],
    }),
    getExternalIssueBanners: builder.query<IExternalIssueBanner[], void>({
      query: () => ({
        url: "/appadmin/external-issue-banners",
      }),
      providesTags: ["ExternalIssueBanners"],
    }),
    createExternalIssueBanner: builder.mutation<IExternalIssueBanner, TExternalIssueBannerInput>({
      query: (body) => ({
        url: "/appadmin/external-issue-banners",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ExternalIssueBanners"],
    }),
    updateExternalIssueBanner: builder.mutation<
      IExternalIssueBanner,
      { bannerId: string; patch: Partial<TExternalIssueBannerInput> }
    >({
      query: (body) => ({
        url: "/appadmin/external-issue-banners",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["ExternalIssueBanners"],
    }),
    deleteExternalIssueBanner: builder.mutation<{ deleted: boolean }, { bannerId: string }>({
      query: (body) => ({
        url: "/appadmin/external-issue-banners/delete",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ExternalIssueBanners"],
    }),
  }),
});

export const {
  useGetActiveExternalIssueBannersQuery,
  useGetExternalIssueBannersQuery,
  useCreateExternalIssueBannerMutation,
  useUpdateExternalIssueBannerMutation,
  useDeleteExternalIssueBannerMutation,
} = externalIssueBannerRTK;
